import { PaginatedResponse } from '../@eencloud/eewc-components/src/service/api-types';

export type PaginatedResponseWithResults<T> = PaginatedResponse & { results?: T[] };

export const retryRequestOnError = async <T>(
  request: () => Promise<T>,
  maxRetryAttempts: number,
  attempts = 1
): Promise<T | undefined> => {
  if (maxRetryAttempts < attempts) {
    const error = new Error('Max retry attempts reached');
    console.error(error);
    throw error;
  }

  try {
    return await request();
  } catch (e) {
    console.error(e);
    return await retryRequestOnError(request, maxRetryAttempts, attempts + 1);
  }
};

export const getAll = async <T>(
  callback: (nextPageToken: string | undefined) => Promise<PaginatedResponseWithResults<T>>,
  maxRetryAttemptsForPage?: number
): Promise<T[] | undefined> => {
  const items: T[] = [];
  let pageToken: string | undefined;

  do {
    const response = maxRetryAttemptsForPage
      ? await retryRequestOnError<PaginatedResponseWithResults<T>>(() => callback(pageToken), maxRetryAttemptsForPage)
      : await callback(pageToken);

    if (!response || !response.results) {
      const error = new Error('Unexpected response format');
      console.error(error);
      throw error;
    }

    response.results.length && items.push(...response.results);
    pageToken = response.nextPageToken;
  } while (pageToken);

  return items;
};
